/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentConnectorsSetupWhatsAppAppWebhook } from "../../funcs/agentConnectorsSetupWhatsAppAppWebhook.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.SetupWhatsAppAppWebhookRequest$inboundSchema,
};

export const tool$agentConnectorsSetupWhatsAppAppWebhook: ToolDefinition<
  typeof args
> = {
  name: "agent-connectors-setup-whats-app-app-webhook",
  description: `Set up a WhatsApp app webhook (Beta)

Beta. Returns the app-level callback URL and verification token that must be saved in Meta before the first WhatsApp phone connector is created. The caller must be allowed to manage the agent. The stable verification token is returned only in this no-store response and is not a Meta access token.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentConnectorsSetupWhatsAppAppWebhook(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
